/**
 * @module oauth
 *
 * @fileOverview Exports methods to make authenticated requests to the backend,
 * using either:
 *
 * (a) grant_type -> password, scope -> customer: used in requests where the
 *     app acts on behalf of a logged-in user. In these requests, the backend
 *     will be able to identify the user associated with a request.
 *
 * (b) grant_type -> client_credentials, scope -> config_read: used in all other
 *     requests, since the backend now protects all routes.
 *
 * Ideally we will never `import axios from 'axios'` anywhere else, and only ever
 * use these oAuth-capable requests. (An obvious exception is when fetching the
 * config token via `fetchConfigToken`: this is the first request we ever make,
 * so it won't have an Authorization header).
 */

import acquisitionTrackingRequest from './src/acquisitionTrackingRequest'
import fetchConfig from './src/fetchConfig'
import fetchConfigToken from './src/fetchConfigToken'
import fetchUserToken from './src/fetchUserToken'
import getAndSaveConfigToken from './src/getAndSaveConfigToken'
import getAndSaveUserToken from './src/getAndSaveUserToken'
import refreshUserToken from './src/refreshUserToken'
import request from './src/request'
import userRequest from './src/userRequest'

const logger = require('debug')('careship:oauth')

// This module shouldn't `export default`, so imports are more explicit.
export {
  fetchConfig,
  fetchConfigToken,
  fetchUserToken, // @TODO: stop exporting the fetches, sdk/oauth should do everything by itself
  getAndSaveConfigToken,
  getAndSaveUserToken,
  logger,
  refreshUserToken,
  request,
  userRequest,
  acquisitionTrackingRequest,
}
